import { LAST_SEARCHS_KEY } from '../consts';

export const getLastSearchs = (): Array<NodeJS.Dict<string | string[]>> => {
  const lastSearchsAsString =
    typeof window === 'undefined'
      ? undefined
      : localStorage.getItem(LAST_SEARCHS_KEY);
  let lastSearchs: Array<NodeJS.Dict<string | string[]>> = lastSearchsAsString
    ? JSON.parse(lastSearchsAsString)
    : [];
  if (!Array.isArray(lastSearchs)) {
    lastSearchs = [];
  }
  return lastSearchs.filter((search) => Object.keys(search).length > 0);
};
